module.exports = {
      id: "arrow-special-usage",
      viewBox: "0 0 33 14",
      url: __webpack_public_path__ + "img/icons.0a12b861.svg#arrow-special-usage",
      toString: function () {
        return this.url;
      }
    }